import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="section-pad container-luxe text-center">
      <p className="overline">404</p>
      <h1 className="font-display text-6xl text-aubergine mt-4">Out of room.</h1>
      <p className="mt-4 text-plumSoft font-light">This page doesn't exist — but the rest of the community does.</p>
      <Link to="/" className="btn-primary mt-10 inline-flex">Take me home</Link>
    </div>
  );
}
